import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from '../../grid-view/grid-view.component';
import { GlobalServices } from '../../../services/global.service';
import { MessagingService } from '../../../services/messaging.service';
import { Listing } from '../../../models/listing.model';
import { Languages } from '../../../models/enums.model';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-my-Unreadmessages',
  templateUrl: './my-Unreadmessages.component.html'
})
export class MyUnreadMessagesComponent implements OnInit
{
  private collection: Listing;
  pageSize = 15;
  isUnread : boolean = true;
  public currentLanguage;
  private itemsMenu: MenuItem[] = [];
  @ViewChild('MyUnreadMessages',{static: false}) gridView: GridViewComponent;
  public currentUser: User = new User();

  constructor(private messagingService: MessagingService, private global: GlobalServices,
              public datepipe: DatePipe, private authenticationService: AuthenticationService,
              private route: Router,private localeService: BsLocaleService,
              private translate: TranslateService)
  {
    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;
  }

  ngOnInit()
  {
    this.global.isLoaderEnabled = true;
    this.currentLanguage = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    if(this.currentUser.IsAdmin)
    {
      this.loadAdminUnreadMessages();
    }
    else
    {
      this.loadUserMessages();
    }

  }

  loadAdminMessages()
  {
      this.messagingService.getAdminMessages(this.currentUser.Email, 0, this.pageSize, this.currentLanguage).subscribe(
        data => this.collection = data.Data,
        () => console.log("Something went wrong!!"),
        () => this.loadAdminCollectionCompleted()
      );
  }
  loadAdminUnreadMessages()
  {
      this.messagingService.getAdminUnreadMessages(this.currentUser.Email, 0, this.pageSize, this.currentLanguage).subscribe(
        data => this.collection = data.Data,
        () => console.log("Something went wrong!!"),
        () => this.loadAdminCollectionCompleted()
      );
  }

  loadUserMessages()
  {
      this.messagingService.getUserMessages(this.currentUser.UserId, 0, this.pageSize, this.currentLanguage).subscribe(
        data => this.collection = data.Data,
        () => console.log("Something went wrong!!"),
        () => this.loadUserCollectionCompleted()
      );
  }

  loadUserCollectionCompleted() {
    this.loadItemsMenu();
    this.gridView.loadGrid(this.collection,this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
                          "Messaging/GetUserMessagesPaged?requestorId=" + this.currentUser.UserId +
                          "&pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
                          "&lang=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"),
                          "SHARED.MyMessages", this.itemsMenu, "", "", 'MyUnreadMessages');
    this.global.isLoaderEnabled = false;
  }

  loadAdminCollectionCompleted() {
    this.loadItemsMenu();
    this.gridView.loadGrid(this.collection,this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
                          "Messaging/GetAdminUnReadMessagesPaged?adminMail=" + this.currentUser.Email +
                          "&pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
                          "&lang=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"),
                          "SHARED.MyMessages", this.itemsMenu, "", "", 'MyUnreadMessages');
    this.global.isLoaderEnabled = false;
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
  }

}

export class MenuItem {
  Title :string;
  TitleAr :string;
};
